import { MktuClass, MktuClassWord } from '@/services/Api/generated'
import { getTypeMktuClassByNumber } from '@/shared/Mktu/utils'
import { makeAutoObservable } from 'mobx'
import { mktuClassListStore } from '../MktuClassList.store'

export class MktuClassStore {
  data: MktuClass

  words: MktuClassWord[] = []
  selectedWords: MktuClassWord[] = []
  selectedWordsNames: string[] = []

  get type() {
    return getTypeMktuClassByNumber(this.data.classNumber)
  }

  constructor(data: MktuClass, words: MktuClassWord[] = []) {
    this.data = data
    this.words = words
    makeAutoObservable(this, {}, { autoBind: true })
  }

  setWords(words: MktuClassWord[]) {
    this.words = words
  }

  get totalWordsCount() {
    return this.data.wordsCount.niceWords + this.data.wordsCount.notNiceWords
  }

  async getWords() {
    const words = await mktuClassListStore.getWords(this.data.classNumber)
    if (words != null) {
      this.setWords(words)
    }
  }

  setSelectedWords(words: MktuClassWord[]) {
    this.selectedWords = words
  }

  selectWord(word: MktuClassWord) {
    if (this.selectedWords.find((w) => w.word === word.word) != null) {
      this.selectedWords = this.selectedWords.filter(
        (w) => w.word !== word.word
      )
    } else {
      this.selectedWords = [...this.selectedWords, word]
    }
  }

  selectAllWords() {
    this.selectedWords = [...this.words]
  }

  selectAllNiceWords() {
    this.selectedWords = [...this.words.filter((w) => w.isNice)]
  }

  resetSelectedWords() {
    this.selectedWords = []
  }

  async setSelectedWordsNames(wordsNames: string[]) {
    this.selectedWordsNames = wordsNames
    await this.getWords()
    const selectedWords: MktuClassWord[] = this.words.filter((word) =>
      this.selectedWordsNames.includes(word.word)
    )

    this.setSelectedWords(selectedWords)
  }

  clone() {
    const newInstance = new MktuClassStore({ ...this.data }, [...this.words])
    newInstance.setSelectedWords([...this.selectedWords])
    return newInstance
  }
}
